<template>
  <div id="trs-header" v-if="showHeader">
    <div :class="tabletMode ? 'container-fluid' : 'container'" id="container-custom" class="nopadding">
      <a class="logo float-left">
        <img src="@/assets/img/trslogo.png"/>
      </a>
      <template v-if="!hideTopMenu">
        <nav>
          <!--show customer name and sso services and logout button-->
          <ul class="nav nav-pills float-right">
            <li class="dropdown">
              <a id="userMenu" data-target="#" href="#" data-toggle="dropdown">
                <span class="d-none d-md-none d-lg-inline" :title="customerFullName">{{customerFullName}}</span>
                <i class="fa fa-caret-down user-icon"></i>
              </a>

              <template v-if="!mobileMode && !tabletMode">
                <ul class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="userMenu">
                  <li v-for="item in userMenus" :key="item.title" :class="{'nav-toggle' : needRegisterPasskey}">
                    <router-link :to="item.href">
                      <i v-if="item.className && item.position === 'left'" :class="item.className"></i>
                      {{ $t(item.title) }}
                      <i v-if="item.className && item.position !== 'left'" :class="item.className"></i>
                    </router-link>
                  </li>
                  <li v-if="headerInfo && headerInfo.homePageUrl" :class="{'nav-toggle' : needRegisterPasskey}">
                    <a :href="headerInfo.homePageUrl">
                      {{ $t('trs.front.title.left.menu.homepage') }}
                      <i class="fas fa-share-square size-icon"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#" @click.prevent="logout">
                      <i class="fas fa-sign-out-alt"></i>
                      {{ $t("trs.front.header.label.logout") }}
                    </a>
                  </li>
                </ul>
              </template>
              <template v-else>
                <ul class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="userMenu">
                  <li v-for="item in userMenus" :key="item.title" style="border-bottom: 1px solid #ddd" :class="{'nav-toggle' : needRegisterPasskey}">
                    <router-link :to="item.href">
                      <i v-if="item.className && item.position === 'left'" :class="item.className"></i>
                      {{ $t(item.title) }}
                      <i v-if="item.className && item.position !== 'left'" :class="item.className"></i>
                    </router-link>
                  </li>
                  <li v-if="headerInfo && headerInfo.homePageUrl" style="border-bottom: 1px solid #ddd" :class="{'nav-toggle' : needRegisterPasskey}">
                    <a :href="headerInfo.homePageUrl">
                      {{ $t('trs.front.title.left.menu.homepage') }}
                      <i class="fas fa-share-square size-icon"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#" @click.prevent="logout" style="height: 25px">
                      <i class="fas fa-sign-out-alt"></i>
                      {{ $t("trs.front.header.label.logout") }}
                    </a>
                  </li>
                </ul>
              </template>
            </li>
          </ul>
          <!--top-menu show by screen width-->
          <ul class="nav nav-pills hidden-resize">
            <li id="home" :class="{'active' : isHomeTabActive, 'nav-toggle' : needRegisterPasskey}">
              <a @click="handleHomeRedirect()">
                {{ $t("trs.front.header.label.mypage") }}
              </a>
            </li>
            <li v-if="!(mobileMode && tabletMode)">
              <a href="#" alt="トレード " id="dropdownSTrelease" aria-expanded="true" data-toggle="dropdown"
                 class="btn-fx" :class="{'nav-toggle' : needRegisterPasskey}">
                {{ $t("trs.front.header.label.fx") }}
              </a>
              <ul aria-labelledby="dropdownSTrelease" role="menu"
                  class="dropdown-menu dropdown-menu-left w250" id="dropdownSTreleaseContent">
                <li class="dropdown-caret">
                  <span class="caret-outer"></span>
                  <span class="caret-inner"></span>
                </li>
                <li role="presentation">
                  <a :href="headerInfo.webtradeExpressUrl">
                    {{ $t("trs.front.header.label.fx.new") }}
                  </a>
                </li>
                <li role="presentation">
                  <a href="#" @click="openPopup($event)">
                    {{ $t("trs.front.header.label.fx.express") }}
                    <i class="fas fa-share-square"></i>
                  </a>
                </li>
              </ul>
            </li>
            <li v-if="mobileMode && tabletMode">
              <a :href="headerInfo.webtradeExpressUrl" :class="{'nav-toggle' : needRegisterPasskey}">
                {{ $t('trs.front.header.label.fx') }}
              </a>
            </li>
            <li :class="{'nav-toggle' : needRegisterPasskey}" v-if="headerInfo && headerInfo.socialCtx != null">
              <a :href="headerInfo.socialCtx">{{ $t("trs.front.header.label.social") }}</a>
            </li>
            <li :class="{'nav-toggle' : needRegisterPasskey}" v-if="headerInfo && headerInfo.boCtx != null">
              <a :href="headerInfo.boCtx + '/customer/home'">{{ $t("trs.front.header.label.bo") }}</a>
            </li>
            <li :class="{'active' : isCryptoTabActive, 'nav-toggle' : needRegisterPasskey}" v-if="headerInfo !== null" id="cryptoMenu">
              <a :href="cryptoRedirectLink()" id="linkMenuCrypto">
                {{ $t("trs.front.header.label.crypt") }}
              </a>
            </li>
          </ul>
          <!--button show/hide left menu-->
          <template v-if="!needRegisterPasskey">
            <button v-show="displayOffCanvasBtn" class="btn btn-offcanvas" @click="toggleOffCanvasMenu"><i class="fa fa-bars"></i></button>
          </template>
        </nav>
      </template>
      <!--only show customer name and logout button-->
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import $ from 'jquery';
  import * as TYPE from '@/store/modules/header/type';
  import * as HEADER_TYPE from '@/store/modules/header/type';
  import Config from "@/services/Config";
  import IConstants from "@/common/constants/IConstants"
  import ModalPlugin from "@/common/plugins/ModalPlugin.js";
  import store from '@/store/index'

  const {mapState: mapNewsState} = createNamespacedHelpers("news");
  const {mapState: mapHeaderState, mapGetters: mapHeaderGetter} = createNamespacedHelpers("header");

export default {
    data() {
        return {
            userMenus: [
                {
                    href: "edit-profile",
                    title: "trs.front.title.left.menu.account_info",
                },
                {
                    href: "customer-support",
                    title: "trs.front.title.left.menu.support",
                }
            ],
            homeTabId: TYPE.MENU_HOME,
            scriptAdded: false
        }
    },
    mounted() {
        $(document).click(function (event) {
            const target = $(event.target);
            if (!$(target).hasClass("btn-offcanvas")) {
                $("#trs-menu,.page").removeClass('offcanvas');
            }
        });
        $(window).resize(function () {
            $("#trs-menu,.page").removeClass('offcanvas');
        });
        ModalPlugin.EventBus.$on(IConstants.EVENT_NAME.MASKING_VERIFY_RESULT + IConstants.SCREEN_NAME.HEADER, () => {
            store.dispatch('header/' + HEADER_TYPE.GET_HEADER_INFO);
        });
    },
    computed: {
        ...mapHeaderState({
            headerInfo: state => state.headerInfo,
            displayOffCanvasBtn: state => state.displayOffCanvasBtn,
        }),
        ...mapNewsState({
            hideTopMenu: state => state.hideTopMenu,
            needRegisterPasskey: state => state.needRegisterPasskey
        }),
        ...mapHeaderGetter([
            'isHomeTabActive',
            'isCryptoTabActive'
        ]),

        customerFullName: function () {
            let customerFullName = "";
            if (this.headerInfo) {
                if (this.headerInfo.corporationType === 1) {
                    if (this.headerInfo.customerFullName.length > 21) {
                        customerFullName =
                            this.headerInfo.customerFullName.substring(0, 21) + "...";
                    } else {
                        customerFullName = this.headerInfo.customerFullName;
                    }
                } else {
                    if (this.headerInfo.customerFullName.length > 22) {
                        customerFullName =
                            this.headerInfo.customerFullName.substring(0, 22) + "...";
                    } else {
                        customerFullName = this.headerInfo.customerFullName;
                    }
                }
            }
            return customerFullName;
        },

        showHeader() {
            return !(this.$route.name && (this.$route.name.includes('login') || this.$route.name.includes("confirmMail")));
        },
    },
    watch: {
        'headerInfo.customerId': {
            handler() {
                if (this.headerInfo.customerId && !this.scriptAdded) {
                    const script = document.createElement('script');
                    script.textContent = `
                          window.dataLayer = window.dataLayer || [];
                          window.dataLayer.push({
                              'uid': '${this.headerInfo.customerId}',
                          });
                      `;
                    $(script).insertBefore("#gg-tag-manager");
                    this.scriptAdded = true;
                }
            },
            deep: true
        }
    },
    methods: {
        cryptoRedirectLink(){
          if (!Config.isUatEnvironment()) {
            return "/account/crypto";
          } return "/mypage/account/crypto";
        },

        handleHomeRedirect() {
            this.$router.push({name: "home"});
        },

        openPopup(event) {
            event.preventDefault();
            const url = this.headerInfo.ntdCtx;
            const params = [
                'height=' + screen.availHeight,
                'width=' + screen.availWidth,
                'menubar=no',
                'toolbar=no',
                'status=no',
                'resizable=yes',
                'fullscreen=yes'
            ].join(',');
            const popup = window.open(url, '_target', params);
            popup.moveTo(0, 0);
        },

        toggleOffCanvasMenu(event) {
            $('#trs-menu,.page').toggleClass('offcanvas');
            event.stopPropagation();
        },

        logout() {
            if (!Config.isUatEnvironment()) {
                this.$cookie.remove(IConstants.SESSION_ID);
            }
            window.location.href = `${window.location.origin}/${Config.getLogoutEndPoint()}`;
        },
    },
};
</script>

<style scoped>
a {
  position: relative;
  display: block;
  cursor: pointer;
}

.btn-fx {
  width: 86px;
  text-align: center;
}

.size-icon {
  font-size: small;
}

#container-custom {
  max-width: 1170px;
}
.nav-toggle {
    display: none;
}

.user-icon {
    margin-left: 4px;
}
</style>
